/*
 * `states` module
 * ===============
 *
 * Declares all present game states.
 * Expose the required game states using this module.
 */

'use strict';

exports.Boot = require('./Boot');
exports.Preloader = require('./Preloader');
exports.Game = require('./Game');
exports.End = require('./End');
exports.Start = require('./Start');
